// Format a number with grouped thousands
function number_format( number, decimals, dec_point, thousands_sep ) {
    //
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://crestidg.com)

    var i, j, kw, kd, km;

    // input sanitation & defaults
    if( isNaN(decimals = Math.abs(decimals)) ){
        decimals = 2;
    }
    if( dec_point == undefined ){
        dec_point = ",";
    }
    if( thousands_sep == undefined ){
        thousands_sep = ".";
    }

    i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

    if( (j = i.length) > 3 ){
        j = j % 3;
    } else{
        j = 0;
    }

    km = (j ? i.substr(0, j) + thousands_sep : "");
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
    //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
    kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");


    return km + kw + kd;
}

function setMobileVersion() {
    $.cookie('is_mobile', '1', {
        path: '/;SameSite=Lax',
        secure: false
    });
    location.reload();
    return false;
}

function langSwitch(lang, href) {
    if (lang && href) {
        $.cookie('site_lng', lang, {
            expires: 365, // 1 year cookie
            path: '/;SameSite=Lax',
            secure: false
        });

        location.href = href;
    }

    return false;
}

function sendToBin(id, formName) {
    formName = typeof formName !== "undefined" ? formName : 'buy_form';
    $('form[name="' + formName + '_' + id + '"]').submit();
    return false;
}

function summa(id, price) {
    var kol = $('#buy_count_' + id).val();
    var s = Math.round(kol * price * 100) / 100;
    $('#summa_' + id).html(number_format(s, 2, ',', ' '));
}

function updateBin(itemId, itemPrice, itemCount) {
    if(itemId != undefined) {
        var s = Math.round(itemCount * itemPrice * 100) / 100;
        var $summa = $('#summa_' + itemId);

        $summa.html(number_format(s, 2, ',', ' '));

        if(itemCount <= 0) {
            $summa.closest('tr').remove(); // remove table row
        }

        $.ajax({
            type : "POST",
            url : "ajax.func.update_bin.php",
            data : {'addbin' : itemId, 'buy_count' : itemCount},
            async : true,
            success : function(data) {
                eval(data);
            },
            error : function(xhr, ajaxOptions, thrownError) {
                console.log("updateBin() Error! " + thrownError);
            }
        });
    }
}

function deleteFromBin(itemId) {
    if(itemId != undefined) {
        $('#summa_' + itemId).closest('tr').remove(); // remove table row

        $.ajax({
            type : "POST",
            url : "ajax.func.update_bin.php",
            data : {'addbin' : itemId, 'buy_count' : 0},
            async : true,
            success : function(data) {
                eval(data);
            },
            error : function(xhr, ajaxOptions, thrownError) {
                console.log("deleteFromBin() Error! " + thrownError);
            }
        });
    }
}

function clearBin() {
    $.ajax({
        type : "POST",
        url : "ajax.func.clear_bin.php",
        data : {'empty_bin' : '1'},
        dataType : "json",
        async : true,
        success : function(json) {
            if(json.clear_bin == true) {
                location.reload();
            }
        },
        error : function(xhr, ajaxOptions, thrownError) {
            console.log("clearBin() Error! " + thrownError);
        }
    });

    return false;
}

function artVote(value, artId) {
    if(value != undefined && artId != undefined) {
        $.ajax({
            type : "POST",
            url : "ajax.func.article_vote.php",
            data : {'vote' : value, 'art_id' : artId},
            async : true,
            success : function(data) {
                eval(data);
            },
            error : function(xhr, ajaxOptions, thrownError) {
                console.log("voteArt() Error! " + thrownError);
            }
        });
    }

    return false;
}

function artComment(comment, artId) {
    if(comment != undefined && artId != undefined) {
        $.ajax({
            type : "POST",
            url : "ajax.func.article_comment.php",
            data : {'comment' : comment, 'art_id' : artId},
            async : true,
            success : function(data) {
                eval(data);
            },
            error : function(xhr, ajaxOptions, thrownError) {
                console.log("artComment() Error! " + thrownError);
            }
        });
    }

    return false;
}

document.addEventListener("DOMContentLoaded", function() {
    // Sticky Header
    var header = document.getElementById("header");
    var headerNav = document.getElementById("headerNav");
    var headerNavOffset = headerNav.offsetTop;
    var headerNavHeight = headerNav.offsetHeight;

    function stickyHeader() {
        if(window.pageYOffset > headerNavOffset) {
            header.classList.add("sticky");
            header.style.paddingTop = headerNavHeight + 'px';
        } else {
            header.classList.remove("sticky");
            header.style.paddingTop = '';
        }
    }

    stickyHeader();


    // Sticky Checkout
    var checkoutSummary = document.getElementById("checkoutSummary");
    var content = document.getElementById("content");

    if (checkoutSummary) {
        var contentOffset = content.offsetTop;
        var checkoutSummaryOffset = contentOffset - headerNavHeight - 10;

        function stickyCheckout() {
            if(window.pageYOffset > checkoutSummaryOffset) {
                checkoutSummary.classList.add("sticky");
                checkoutSummary.style.top = (headerNavHeight + 40) + 'px';
            } else {
                checkoutSummary.classList.remove("sticky");
                checkoutSummary.style.top = '';
            }
        }

        stickyCheckout();
    }

    window.onscroll = function() {
        stickyHeader();

        if (checkoutSummary) {
            stickyCheckout();
        }
    };
});

/* ---------------------------------------------------------------------------
 * # Scrool to top
 * --------------------------------------------------------------------------- */
function scroolTop() {
    var $toTopButton = $("#toTop");

    if($(window).scrollTop() >= "250") {
        $toTopButton.addClass('visible');
    }

    $(window).scroll(function(){
        if($(window).scrollTop() <= "250") {
            $toTopButton.removeClass('visible');
        } else {
            $toTopButton.addClass('visible');
        }
    });

    $toTopButton.on('click', function(){
        $("html, body").animate({
            scrollTop: 0
        }, 500, 'swing');
    })
}

/* ---------------------------------------------------------------------------
 * # Hash smooth navigation
 * --------------------------------------------------------------------------- */
function hashSmoothNavigation() {
    var hash = window.location.hash;

    if (hash) {
        if ($(hash).length) {
            var headerNavHeight = $("#headerNav").outerHeight();
            var topOffset = $(hash).offset().top;
            var scrollTop = topOffset - ( headerNavHeight + 10 );

            $('html, body').animate({
                scrollTop: scrollTop
            }, 500, 'swing');
        }
    }
}

/* ---------------------------------------------------------------------------
 * # One page smooth navigation
 * --------------------------------------------------------------------------- */
function onePageSmoothNavigation() {
    var menu = $('#mainMenu');

    $('a[href]', menu).each(function() {
        var url = $(this).attr( 'href' );

        if(url && url.split('#')[1]) {
            // data-hash
            var hash = '#' + url.split('#')[1];

            if (hash && $(hash).length) {				// check if element with specified ID exists
                $(this).attr( 'data-hash', hash );
                $(hash).attr( 'data-id', hash );
            }
        }
    });

    // click
    menu.find('a[data-hash]').on('click', function(e) {
        e.preventDefault();

        var hash = $(this).attr('data-hash');
        var headerNavHeight = $("#headerNav").outerHeight();
        var topOffset = $(hash).offset().top;
        var scrollTop = topOffset - ( headerNavHeight + 10 );

        $('html, body').animate({
            scrollTop: scrollTop
        }, 500, 'swing');
    });
}

/* ---------------------------------------------------------------------------
 * # One page active menu item
 * --------------------------------------------------------------------------- */
function onePageActive() {
    var menu = $('#mainMenu');

    var windowTop = $(window).scrollTop();
    var headerNavHeight = $("#headerNav").outerHeight();
    var start	= windowTop + headerNavHeight + 11;
    var activeBlock = false;

    $('div[data-id]').each(function() {

        var elemTop = $(this).offset().top;
        var elemHeight = $(this).outerHeight();

        if ($(this).is(':visible')) {
            if (!activeBlock && (elemTop <= start) && ((elemTop + elemHeight) > start)) {
                activeBlock = $(this);
            }
        }

        menu.find('a').removeClass('disable-active current');

        if (activeBlock) {
            var newActive = activeBlock.attr('data-id');
            var active = '[data-hash="'+ newActive +'"]';

            if (newActive) {
                $('a.active', menu).addClass('disable-active');
                $(active, menu).addClass('current');
            }
        }
    });
}


$(window).load(function() {
    // Scroll on load if #hashtag set in URL
    hashSmoothNavigation();

    // Scroll on click by menu item
    onePageSmoothNavigation();

    // Scroll to top
    scroolTop();
});

$(window).scroll(function(){
    // One Page | Scroll | Active Section
    // onePageActive();
});
